import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SearchState } from '../states/search.state';

const selectSearhcState = createFeatureSelector<SearchState>('search');

export const selectPatternSearchResults = createSelector(selectSearhcState, onMarketToolbarState => onMarketToolbarState.patternSearchResults);